/* eslint-disable */
/* eslint-disable no-restricted-globals, no-undef */
import {
  Box,
  Button,
  ButtonGroup,
  Flex,
  Grid,
  IconButton,
  Select,
  Text,
  useBreakpointValue,
  HStack,
  VStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
  Input,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Checkbox,
  Stack,
  Progress,
  Badge,
  Heading,
  Spinner,
  Divider,
  Textarea,
  useColorModeValue
} from "@chakra-ui/react";
import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DEPARTMENTS } from "../../constants/departments";
import { Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react";
import { AddIcon, EditIcon } from "@chakra-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import convertDateFormat, {
  deleteProduct,
  getProduct,
} from "../../Redux/AdminReducer/action";
import Pagination from "./Pagination";
import AdminNavTop from "../AdminNavTop";
import Navbar from "../UserComponents/UserNavbar";
import axios from "axios";
import { useModalToast } from "../../context/GlobalModalToast";

const Courses = () => {
  const store = useSelector((store) => store.AdminReducer.data);
  const dispatch = useDispatch();
  const { toast, confirm } = useModalToast();
  const [coursesList, setCoursesList] = useState([]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [order, setOrder] = useState("desc");
  const [sortBy, setSortBy] = useState("createdAt");
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const limit = 4;
  const userRole = useSelector(state => state.UserReducer.role);
  const fileInputRef = useRef(null);
  const bundleContainerBg = useColorModeValue("white", "rgba(15, 23, 42, 0.7)");
  const bundleContainerBorder = useColorModeValue("purple.100", "rgba(255, 255, 255, 0.08)");
  const bundleCardBg = useColorModeValue("purple.50", "rgba(15, 23, 42, 0.5)");
  const bundleCardBorder = useColorModeValue("purple.200", "rgba(255, 255, 255, 0.08)");
  const emptyBundleBg = useColorModeValue("purple.50", "rgba(15, 23, 42, 0.4)");
  const emptyBundleBorder = useColorModeValue("purple.200", "rgba(255, 255, 255, 0.1)");
  const headingColor = useColorModeValue("gray.800", "white");
  const textColor = useColorModeValue("gray.500", "gray.300");
  const creatorTextColor = useColorModeValue("gray.400", "gray.400");
  const courseSize = useBreakpointValue({ base: "md", sm: "lg", md: "xl" });
  const tableSize = useBreakpointValue({ base: "sm", sm: "md", md: "lg" });

  const { isOpen: isAssignOpen, onOpen: onAssignOpen, onClose: onAssignClose } = useDisclosure();
  const { isOpen: isReportOpen, onOpen: onReportOpen, onClose: onReportClose } = useDisclosure();
  const [activeCourseId, setActiveCourseId] = useState("");
  const [activeCourseTitle, setActiveCourseTitle] = useState("");
  const [assignMode, setAssignMode] = useState("individual");
  const [assignEmail, setAssignEmail] = useState("");
  const [assignDept, setAssignDept] = useState("All");
  const [assignCompany, setAssignCompany] = useState("All");
  const [assignDueDate, setAssignDueDate] = useState("");
  const [isAssigning, setIsAssigning] = useState(false);
  const [enrollmentReport, setEnrollmentReport] = useState([]);
  const [isReportLoading, setIsReportLoading] = useState(false);
  const [reportStartDate, setReportStartDate] = useState("");
  const [reportEndDate, setReportEndDate] = useState("");

  // Course Bundles features
  const [activeTab, setActiveTab] = useState("courses");
  const [bundles, setBundles] = useState([]);
  const [isBundlesLoading, setIsBundlesLoading] = useState(false);
  const { isOpen: isCreateBundleOpen, onOpen: onCreateBundleOpen, onClose: onCreateBundleClose } = useDisclosure();
  const { isOpen: isBundleInviteOpen, onOpen: onBundleInviteOpen, onClose: onBundleInviteClose } = useDisclosure();
  const [bundleTitle, setBundleTitle] = useState("");
  const [bundleDesc, setBundleDesc] = useState("");
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [activeBundleId, setActiveBundleId] = useState("");
  const [activeBundleTitle, setActiveBundleTitle] = useState("");
  const [bundleInviteEmail, setBundleInviteEmail] = useState("");
  const [bundleInviteDueDate, setBundleInviteDueDate] = useState("");
  const [isInviteSubmitting, setIsInviteSubmitting] = useState(false);
  const [isBundleCreating, setIsBundleCreating] = useState(false);
  const [isBundleEditMode, setIsBundleEditMode] = useState(false);
  const [allCoursesRaw, setAllCoursesRaw] = useState([]);

  const fetchBundles = async () => {
    setIsBundlesLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('user'))?.token || "";
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/courses/bundles`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBundles(res.data);
    } catch (err) {
      console.error("Failed to load course bundles", err);
    } finally {
      setIsBundlesLoading(false);
    }
  };

  const fetchAllCoursesRaw = async () => {
    try {
      const token = JSON.parse(localStorage.getItem('user'))?.token || "";
      // Fetch all courses without pagination for selection list
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/courses?limit=100`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAllCoursesRaw(res.data.course || res.data.courses || (Array.isArray(res.data) ? res.data : []));
    } catch (err) {
      console.error("Failed to load all courses raw list", err);
    }
  };

  useEffect(() => {
    if (activeTab === "bundles") {
      fetchBundles();
      fetchAllCoursesRaw();
    }
  }, [activeTab]);

  const handleOpenCreateBundle = () => {
    fetchAllCoursesRaw();
    setIsBundleEditMode(false);
    setSelectedCourses([]);
    setBundleTitle("");
    setBundleDesc("");
    onCreateBundleOpen();
  };

  const handleOpenEditBundle = (bundle) => {
    fetchAllCoursesRaw();
    setIsBundleEditMode(true);
    setActiveBundleId(bundle._id);
    setBundleTitle(bundle.title);
    setBundleDesc(bundle.description || "");
    setSelectedCourses(bundle.courses?.map(c => c._id || c) || []);
    onCreateBundleOpen();
  };

  const handleCreateBundleSubmit = async () => {
    if (!bundleTitle.trim()) {
      toast({ title: "Missing Title", description: "Please enter a bundle title.", status: "warning" });
      return;
    }
    if (selectedCourses.length === 0) {
      toast({ title: "No Courses", description: "Please select at least one course for the bundle.", status: "warning" });
      return;
    }
    setIsBundleCreating(true);
    try {
      const token = JSON.parse(localStorage.getItem('user'))?.token || "";
      if (isBundleEditMode) {
        await axios.put(`${process.env.REACT_APP_API_URL}/api/courses/bundles/${activeBundleId}`, {
          title: bundleTitle,
          description: bundleDesc,
          courses: selectedCourses
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast({ title: "Bundle Updated", status: "success", duration: 2000 });
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/api/courses/bundles/add`, {
          title: bundleTitle,
          description: bundleDesc,
          courses: selectedCourses
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast({ title: "Bundle Created", status: "success", duration: 2000 });
      }
      onCreateBundleClose();
      setBundleTitle("");
      setBundleDesc("");
      setSelectedCourses([]);
      fetchBundles();
    } catch (err) {
      toast({ title: "Error", description: "Failed to save bundle: " + (err.response?.data?.message || err.message), status: "error" });
    } finally {
      setIsBundleCreating(false);
    }
  };

  const handleBundleInviteSubmit = async () => {
    if (!bundleInviteEmail.trim()) {
      toast({ title: "Missing Email", description: "Please enter a valid employee email address.", status: "warning" });
      return;
    }
    setIsInviteSubmitting(true);
    try {
      const token = JSON.parse(localStorage.getItem('user'))?.token || "";
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/courses/bundles/${activeBundleId}/invite`, {
        email: bundleInviteEmail,
        dueDate: bundleInviteDueDate || undefined
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast({ title: "Invite Sent", description: res.data.message, status: "success", duration: 2000 });
      onBundleInviteClose();
      setBundleInviteEmail("");
      setBundleInviteDueDate("");
    } catch (err) {
      toast({ title: "Error", description: "Failed to send bundle invite: " + (err.response?.data?.message || err.message), status: "error" });
    } finally {
      setIsInviteSubmitting(false);
    }
  };

  const handleDeleteBundle = async (bundleId, bundleTitle) => {
    const confirmed = await confirm({ title: "Delete Bundle", description: `Are you sure you want to delete the bundle "${bundleTitle}"? This will not delete the individual courses.`, confirmText: "Delete", status: "warning" });
    if (!confirmed) return;
    try {
      const token = JSON.parse(localStorage.getItem('user'))?.token || "";
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/courses/bundles/${bundleId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast({ title: "Bundle Deleted", description: `"${bundleTitle}" has been removed.`, status: "success", duration: 2000 });
      fetchBundles();
    } catch (err) {
      toast({ title: "Error", description: "Failed to delete bundle: " + (err.response?.data?.message || err.message), status: "error" });
    }
  };

  const handleDownloadCSV = async () => {
    try {
      const token = JSON.parse(localStorage.getItem('user'))?.token || "";
      let endpoint = activeCourseId
        ? `${process.env.REACT_APP_API_URL}/api/reports/progress/csv/${activeCourseId}`
        : `${process.env.REACT_APP_API_URL}/api/reports/progress/csv`;
      
      const queryParams = new URLSearchParams();
      if (reportStartDate) queryParams.append('startDate', reportStartDate);
      if (reportEndDate) queryParams.append('endDate', reportEndDate);
      const queryString = queryParams.toString();
      if (queryString) endpoint += `?${queryString}`;
      const res = await axios.get(endpoint, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
      });
      
      const blob = new Blob([res.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `SkillUp_Progress_${activeCourseTitle || 'All'}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      toast({ title: "Download Error", description: "Failed to download CSV: " + (err.response?.data?.message || err.message), status: "error" });
    }
  };

  const handleDownloadExcel = async () => {
    try {
      const token = JSON.parse(localStorage.getItem('user'))?.token || "";
      let endpoint = activeCourseId
        ? `${process.env.REACT_APP_API_URL}/api/reports/progress/excel/${activeCourseId}`
        : `${process.env.REACT_APP_API_URL}/api/reports/progress/excel`;
      
      const queryParams = new URLSearchParams();
      if (reportStartDate) queryParams.append('startDate', reportStartDate);
      if (reportEndDate) queryParams.append('endDate', reportEndDate);
      const queryString = queryParams.toString();
      if (queryString) endpoint += `?${queryString}`;
      const res = await axios.get(endpoint, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
      });
      
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `SkillUp_Progress_${activeCourseTitle || 'All'}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      toast({ title: "Download Error", description: "Failed to download Excel: " + (err.response?.data?.message || err.message), status: "error" });
    }
  };


  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  const handleSelect = (e) => {
    const { value } = e.target;
    // value is like "createdAt_desc", "createdAt_asc", "title_asc", "title_desc"
    const [field, dir] = value.split('_');
    setSortBy(field);
    setOrder(dir);
  };

  useEffect(() => {
    dispatch(getProduct(page, limit, search, order, sortBy, selectedCompany, selectedCategory));
  }, [page, search, order, sortBy, limit, selectedCompany, selectedCategory, dispatch]);

  useEffect(() => {
    if (userRole === "super_admin") {
      const fetchCompanies = async () => {
        try {
          const token = JSON.parse(localStorage.getItem("user"))?.token || "";
          const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/companies`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setCompanies(res.data);
        } catch (err) {
          console.error("Failed to fetch companies", err);
        }
      };
      fetchCompanies();
    }
  }, [userRole]);

  useEffect(() => {
    if (store) {
      setCoursesList(store);
    }
  }, [store]);

  const handleDelete = (id, title) => {
    dispatch(deleteProduct(id));
    setCoursesList(prev => prev.filter(c => c._id !== id));
    toast({ title: `${title} Deleted`, status: "success", duration: 2000 });
  };

  const handleToggleInviteOnly = async (courseId) => {
    try {
      const token = JSON.parse(localStorage.getItem('user'))?.token || "";
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/courses/${courseId}/toggle-invite-only`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setCoursesList(prev => prev.map(c => c._id === courseId ? { ...c, isInviteOnly: res.data.isInviteOnly } : c));
      toast({ title: "Status Updated", description: res.data.message, status: "success", duration: 2000 });
    } catch (err) {
      toast({ title: "Error", description: "Failed to update course status", status: "error" });
    }
  };

  const handleToggleStatus = async (courseId) => {
    try {
      const token = JSON.parse(localStorage.getItem('user'))?.token || "";
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/courses/${courseId}/toggle-status`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setCoursesList(prev => prev.map(c => c._id === courseId ? { ...c, isDisabled: res.data.isDisabled } : c));
      toast({ title: "Status Updated", description: res.data.message, status: "success", duration: 2000 });
    } catch (err) {
      toast({ title: "Error", description: err.response?.data?.message || "Failed to update course status", status: "error" });
    }
  };

  const handleOpenAssignModal = (courseId, title) => {
    setActiveCourseId(courseId);
    setActiveCourseTitle(title);
    onAssignOpen();
  };

  const handleOpenProgressReport = async (courseId, courseTitle) => {
    setActiveCourseId(courseId);
    setActiveCourseTitle(courseTitle);
    onReportOpen();
    setIsReportLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('user'))?.token || "";
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/enrollments/course/${courseId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEnrollmentReport(res.data);
    } catch (err) {
      console.error("Failed to load course progress report", err);
    } finally {
      setIsReportLoading(false);
    }
  };

  const handleAssignSubmit = async () => {
    if (assignMode === 'individual') {
      if (!assignEmail.trim()) {
        toast({ title: "Missing Email", description: "Please enter a valid employee email address.", status: "warning" });
        return;
      }
      setIsAssigning(true);
      try {
        const token = JSON.parse(localStorage.getItem('user'))?.token || "";
        await axios.post(`${process.env.REACT_APP_API_URL}/api/courses/${activeCourseId}/invite`, {
          email: assignEmail,
          dueDate: assignDueDate || undefined
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast({ title: "Invite Sent", description: `Successfully invited ${assignEmail} to this course!`, status: "success", duration: 2000 });
        onAssignClose();
        setAssignEmail("");
        setAssignDueDate("");
      } catch (err) {
        toast({ title: "Error", description: "Failed to send invite: " + (err.response?.data?.message || err.message), status: "error" });
      } finally {
        setIsAssigning(false);
      }
    } else {
      setIsAssigning(true);
      try {
        const token = JSON.parse(localStorage.getItem('user'))?.token || "";
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/enrollments/bulk-assign`, {
          courseId: activeCourseId,
          department: assignDept,
          companyId: assignCompany,
          dueDate: assignDueDate || undefined
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast({ title: "Assignment Complete", description: res.data.message, status: "success", duration: 2000 });
        onAssignClose();
        setAssignDueDate("");
      } catch (err) {
        toast({ title: "Error", description: "Failed to complete group assignment: " + (err.response?.data?.message || err.message), status: "error" });
      } finally {
        setIsAssigning(false);
      }
    }
  };

  const handleDownloadTemplate = async () => {
    try {
      const token = JSON.parse(localStorage.getItem('user'))?.token || "";
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/courses/bulk-template`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
      });
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Course_Bulk_Upload_Template.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      toast({ title: "Error", description: "Failed to download template", status: "error" });
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      toast({ title: "Uploading...", description: "Please wait while we process the Excel file.", status: "info" });
      const token = JSON.parse(localStorage.getItem('user'))?.token || "";
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/courses/bulk-upload`, formData, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      toast({ title: "Success", description: res.data.message, status: "success", duration: 3000 });
      dispatch(getProduct(page, limit, search, order, sortBy, selectedCompany)); // refresh list
    } catch (err) {
      toast({ title: "Upload Failed", description: err.response?.data?.message || err.message, status: "error" });
    } finally {
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const handlePageChange = (page) => {
    setPage(page);
  };
  const count = 4;

  const handlePageButton = (val) => {
    setPage((prev) => prev + val);
  };

  return (
    <Box w="100%">
      <Box>
        <AdminNavTop handleSearch={handleSearch} />

        {/* PREMIUM SUB-TAB BAR */}
        <Flex gap={3} my={6} borderBottom="2px solid" borderColor={bundleContainerBorder} pb={3} px={4}>
          <Button 
            variant={activeTab === "courses" ? "solid" : "ghost"}
            colorScheme={activeTab === "courses" ? "purple" : "gray"}
            onClick={() => setActiveTab("courses")}
            borderRadius="xl"
            fontWeight="bold"
            px={6}
          >
            📚 Active Courses
          </Button>
          <Button 
            variant={activeTab === "bundles" ? "solid" : "ghost"}
            colorScheme={activeTab === "bundles" ? "purple" : "gray"}
            onClick={() => setActiveTab("bundles")}
            borderRadius="xl"
            fontWeight="bold"
            px={6}
          >
            📦 Course Bundles
          </Button>
        </Flex>

        {activeTab === "courses" ? (
          <Box className={`course ${courseSize}`}>
            <Grid
              templateColumns={{
                xl: "repeat(3,20% 60% 20%)",
                lg: "repeat(3,20% 60% 20%)",
                base: "repeat(1,1fr)",
              }}
              gap={{ xl: 0, lg: 0, base: 7 }}
            >
              <Text fontWeight={"bold"}>Course Management</Text>
              <Flex gap={4}>
                {userRole === "super_admin" && (
                  <Select
                    size="sm"
                    borderRadius="xl"
                    w="150px"
                    onChange={(e) => setSelectedCompany(e.target.value)}
                    placeholder="All Branches"
                  >
                    {companies.map(c => (
                      <option key={c.companyId} value={c.companyId}>{c.companyName}</option>
                    ))}
                  </Select>
                )}
                <Select
                  size="sm"
                  borderRadius="xl"
                  w={{ base: "100%", md: "150px" }}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                  placeholder="All Departments"
                >
                  {DEPARTMENTS.map((dept) => (
                    <option key={dept} value={dept}>{dept}</option>
                  ))}
                </Select>
                <Select
                  size="sm"
                  borderRadius="xl"
                  w="200px"
                  onChange={handleSelect}
                  defaultValue="createdAt_desc"
                >
                  <option value="createdAt_desc">📅 Latest First (Default)</option>
                  <option value="createdAt_asc">📅 Oldest First</option>
                  <option value="title_asc">🔤 Title A → Z</option>
                  <option value="title_desc">🔤 Title Z → A</option>
                </Select>
              </Flex>
              <Box fontWeight={"bold"} display="flex" gap={2} flexDirection={{ base: "column", xl: "row" }}>
                <Button as={Link} to="/admin/addCourse" colorScheme="purple" size="sm" borderRadius="xl">
                  + Create Course
                </Button>
                <Button colorScheme="green" size="sm" borderRadius="xl" onClick={handleDownloadTemplate} variant="outline">
                  Download Template
                </Button>
                <Button colorScheme="green" size="sm" borderRadius="xl" onClick={() => fileInputRef.current?.click()}>
                  Excel Upload
                </Button>
                <input 
                  type="file" 
                  ref={fileInputRef} 
                  style={{ display: "none" }} 
                  accept=".xlsx, .xls, .zip"
                  onChange={handleFileUpload} 
                />
              </Box>
            </Grid>
            <Box
              w={{ xl: "100%", lg: "90%", md: "80%", base: "80%" }}
              overflowX="auto"
            >
              <Table
                variant="striped"
                borderRadius="md"
                w="100%"
                size={tableSize}
              >
                <Thead>
                  <Tr>
                    <Th>Title</Th>
                    <Th>Date</Th>
                    <Th>Category</Th>
                    <Th>Description</Th>
                    <Th>Instructor</Th>
                    <Th>Actions & Privacy</Th>
                  </Tr>
                </Thead>
                {coursesList?.length > 0 &&
                  coursesList?.map((el, i) => {
                    return (
                      <Tbody key={i}>
                        <Tr>
                          <Td>
                            <VStack align="flex-start" spacing={1.5}>
                              <Text fontWeight="800" fontSize="sm" color={headingColor}>{el?.title}</Text>
                              {userRole === "super_admin" && el?.companyId && (
                                <Badge colorScheme="purple" variant="outline" fontSize="9px">
                                  🏢 BRANCH: {companies.find(c => c.companyId === el.companyId)?.companyName || "Unknown"}
                                </Badge>
                              )}
                              <HStack spacing={1.5} wrap="wrap">
                                {el?.isInviteOnly ? (
                                  <Badge colorScheme="orange" variant="solid" borderRadius="full" px={2} py={0.5} fontSize="9px" fontWeight="800">
                                    🔒 PRIVATE
                                  </Badge>
                                ) : (
                                  <Badge colorScheme="green" variant="solid" borderRadius="full" px={2} py={0.5} fontSize="9px" fontWeight="800">
                                    🔓 PUBLIC
                                  </Badge>
                                )}
                                
                                {el?.isInviteOnly ? (
                                  <Badge colorScheme="purple" variant="subtle" borderRadius="full" px={2} py={0.5} fontSize="9px" fontWeight="800">
                                    🎯 COMPLIANCE
                                  </Badge>
                                ) : (
                                  <Badge colorScheme="gray" variant="subtle" borderRadius="full" px={2} py={0.5} fontSize="9px" fontWeight="800">
                                    🌐 STANDARD
                                  </Badge>
                                )}

                                {el?.isDisabled && (
                                  <Badge colorScheme="red" variant="solid" borderRadius="full" px={2} py={0.5} fontSize="9px" fontWeight="800">
                                    🛑 DISABLED
                                  </Badge>
                                )}

                                {el?.targetSectors?.length > 0 && (
                                  <Badge colorScheme="purple" variant="subtle" borderRadius="full" px={2} py={0.5} fontSize="9px" fontWeight="800">
                                    👥 ASSIGNED: {el.targetSectors.join(', ')}
                                  </Badge>
                                )}
                              </HStack>
                            </VStack>
                          </Td>
                          <Td>{convertDateFormat(el?.createdAt)}</Td>
                          <Td>{el?.category || "N/A"}</Td>
                          <Td maxW="200px" isTruncated>{el?.description}</Td>
                          <Td>{el?.teacher || el?.createdBy?.fullName || "Admin"}</Td>
                          <Td>
                            <VStack align="stretch" spacing={2}>
                              <HStack spacing={2}>
                                <Button
                                  size="sm"
                                  colorScheme="red"
                                  variant="ghost"
                                  onClick={() => handleDelete(el?._id, el?.title)}
                                >
                                  Delete
                                </Button>
                                <Link to={`/admin/edit/${el?._id}`}>
                                  <Button size="sm" colorScheme="purple" variant="outline">
                                    Edit Course
                                  </Button>
                                </Link>
                              </HStack>
                              
                              <HStack spacing={2} wrap="wrap">
                                <Button
                                  size="xs"
                                  colorScheme={el.isInviteOnly ? "orange" : "green"}
                                  onClick={() => handleToggleInviteOnly(el._id)}
                                >
                                  {el.isInviteOnly ? "🔒 Private" : "🔓 Public"}
                                </Button>
                                <Button
                                  size="xs"
                                  colorScheme={el.isDisabled ? "green" : "red"}
                                  onClick={() => handleToggleStatus(el._id)}
                                >
                                  {el.isDisabled ? "✅ Enable" : "🛑 Disable"}
                                </Button>
                                <Button
                                  size="xs"
                                  colorScheme="purple"
                                  onClick={() => handleOpenAssignModal(el._id, el.title)}
                                >
                                  + Assign Training
                                </Button>
                                <Button
                                  size="xs"
                                  colorScheme="purple"
                                  onClick={() => handleOpenProgressReport(el._id, el.title)}
                                >
                                  📊 Compliance
                                </Button>
                              </HStack>
                            </VStack>
                          </Td>
                        </Tr>
                      </Tbody>
                    );
                  })}
              </Table>
            </Box>
            <Box textAlign={{ xl: "right", lg: "right", base: "left" }} display="flex" gap={2} justifyContent={{ xl: "flex-end", lg: "flex-end", base: "flex-start" }} alignItems="center">
              <Button 
                colorScheme="purple" 
                variant="outline" 
                borderRadius="xl"
                isDisabled={page <= 1} 
                onClick={() => handlePageButton(-1)}
              >
                Prev
              </Button>
              <Pagination
                totalCount={count}
                current_page={page}
                handlePageChange={handlePageChange}
              />
              <Button
                colorScheme="purple" 
                variant="outline" 
                borderRadius="xl"
                isDisabled={page >= count}
                onClick={() => handlePageButton(1)}
              >
                Next
              </Button>
            </Box>
          </Box>
        ) : (
          /* PREMIUM COURSE BUNDLES SUB-VIEW */
          <Box bg={bundleContainerBg} borderRadius="3xl" p={6} border="1px solid" borderColor={bundleContainerBorder} boxShadow="sm" mx={4}>
            <Flex justify="space-between" align="center" mb={6} wrap="wrap" gap={4}>
              <VStack align="flex-start" spacing={1}>
                <Heading size="md" color={headingColor} fontWeight="800">📦 Course Bundles Dashboard</Heading>
                <Text fontSize="xs" color={textColor} fontWeight="600">Combine multiple courses together as unified compliance-tracked bundles.</Text>
              </VStack>
              <Button 
                bgGradient="linear(to-r, purple.500, purple.600)"
                color="white" 
                borderRadius="xl" 
                onClick={handleOpenCreateBundle}
                _hover={{ bgGradient: "linear(to-r, purple.600, purple.700)", transform: "translateY(-2px)" }}
                _active={{ bgGradient: "linear(to-r, purple.600, purple.700)" }}
                transition="all 0.2s"
              >
                + Create Course Bundle
              </Button>
            </Flex>

            {isBundlesLoading ? (
              <VStack py={20}>
                <Spinner size="xl" color="purple.500" />
                <Text color={textColor} mt={4} fontWeight="semibold">Loading course bundles...</Text>
              </VStack>
            ) : bundles.length === 0 ? (
              <VStack py={20} spacing={2} textAlign="center" bg={emptyBundleBg} borderRadius="2xl" border="1px dashed" borderColor={emptyBundleBorder}>
                <Text fontSize="lg" fontWeight="700" color={headingColor}>No Bundles Created Yet</Text>
                <Text color={textColor} fontSize="sm">Combine your SkillUp training modules to assign curated multi-course cohorts with unified deadlines.</Text>
              </VStack>
            ) : (
              <Grid templateColumns={{ base: "1fr", lg: "repeat(2, 1fr)" }} gap={6}>
                {bundles.map((bundle) => (
                  <Box 
                    key={bundle._id} 
                    border="1px solid" 
                    borderColor={bundleCardBorder} 
                    borderRadius="2xl" 
                    p={5} 
                    bg={bundleCardBg} 
                    boxShadow="sm"
                    _hover={{ boxShadow: "md", transform: "translateY(-2px)" }}
                    transition="all 0.2s"
                  >
                    <VStack align="stretch" spacing={4}>
                      <Box>
                        <Heading size="sm" color={headingColor} fontWeight="800">{bundle.title}</Heading>
                        <Text fontSize="xs" color={textColor} mt={1}>{bundle.description || "No description provided."}</Text>
                      </Box>
                      
                      <Divider />

                      <Box>
                        <Text fontSize="xs" fontWeight="700" color="purple.700" mb={2} textTransform="uppercase" letterSpacing="0.5px">
                          Included Courses ({bundle.courses?.length || 0})
                        </Text>
                        <Flex wrap="wrap" gap={2}>
                          {bundle.courses?.map((course) => (
                            <Badge 
                              key={course._id} 
                              colorScheme="purple" 
                              variant="subtle" 
                              borderRadius="lg" 
                              px={3} 
                              py={1} 
                              fontSize="xs"
                              fontWeight="600"
                            >
                              📚 {course.title}
                            </Badge>
                          ))}
                        </Flex>
                      </Box>

                      <Divider />

                      <Flex justify="space-between" align="center" wrap="wrap" gap={3}>
                        <Text fontSize="xs" color={creatorTextColor}>Created by: {bundle.createdBy?.fullName || "Admin"}</Text>
                        <HStack spacing={2}>
                          <Button 
                            size="sm" 
                            colorScheme="red" 
                            variant="ghost"
                            borderRadius="xl"
                            onClick={() => handleDeleteBundle(bundle._id, bundle.title)}
                          >
                            Delete
                          </Button>
                          <Button 
                            size="sm" 
                            colorScheme="purple" 
                            variant="outline"
                            borderRadius="xl"
                            onClick={() => handleOpenEditBundle(bundle)}
                          >
                            Edit
                          </Button>
                          <Button 
                            size="sm" 
                            bgGradient="linear(to-r, purple.500, purple.600)"
                            color="white" 
                            borderRadius="xl"
                            onClick={() => {
                              setActiveBundleId(bundle._id);
                              setActiveBundleTitle(bundle.title);
                              onBundleInviteOpen();
                            }}
                            _hover={{ bgGradient: "linear(to-r, purple.600, purple.700)", transform: "translateY(-1px)" }}
                            _active={{ bgGradient: "linear(to-r, purple.600, purple.700)" }}
                            transition="all 0.2s"
                          >
                            🚀 Invite Employee
                          </Button>
                        </HStack>
                      </Flex>
                    </VStack>
                  </Box>
                ))}
              </Grid>
            )}
          </Box>
        )}
      </Box>

      {/* ASSIGN TRAINING MODAL */}
      <Modal isOpen={isAssignOpen} onClose={onAssignClose} size="lg">
        <ModalOverlay backdropFilter="blur(8px)" />
        <ModalContent borderRadius="2xl" overflow="hidden" boxShadow="2xl" bg={bundleContainerBg} color={headingColor}>
          <ModalHeader className="premium-gradient" color="white" py={5}>
            <VStack align="flex-start" spacing={1}>
              <Text fontSize="lg" fontWeight="800">🎯 Assign Corporate Training</Text>
              <Text fontSize="xs" opacity={0.9} fontWeight="semibold">Course: {activeCourseTitle}</Text>
            </VStack>
          </ModalHeader>
          <ModalCloseButton color="white" top={4} />
          <ModalBody p={6} bg={emptyBundleBg}>
            <VStack spacing={5} align="stretch">
              <FormControl>
                <FormLabel fontWeight="700" color={headingColor} fontSize="sm">Assignment Mode</FormLabel>
                <RadioGroup value={assignMode} onChange={setAssignMode} colorScheme="purple">
                  <HStack spacing={6}>
                    <Radio value="individual">👤 Individual Employee</Radio>
                    <Radio value="group">👥 Group / Department</Radio>
                  </HStack>
                </RadioGroup>
              </FormControl>

              {assignMode === 'individual' ? (
                <FormControl isRequired>
                  <FormLabel fontWeight="700" color={headingColor} fontSize="sm">Employee Corporate Email</FormLabel>
                  <Input 
                    placeholder="employee@company.com" 
                    bg={bundleContainerBg} 
                    borderRadius="xl"
                    value={assignEmail} 
                    onChange={(e) => setAssignEmail(e.target.value)} 
                  />
                </FormControl>
              ) : (
                <>
                  {userRole === "super_admin" && (
                    <FormControl isRequired mb={4}>
                      <FormLabel fontWeight="700" color={headingColor} fontSize="sm">Select Target Branch / Company</FormLabel>
                      <Select 
                        bg={bundleContainerBg} 
                        borderRadius="xl" 
                        value={assignCompany} 
                        onChange={(e) => setAssignCompany(e.target.value)}
                      >
                        <option value="All">All Branches</option>
                        {companies.map(c => (
                          <option key={c.companyId} value={c.companyId}>{c.companyName}</option>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                  <FormControl isRequired>
                    <FormLabel fontWeight="700" color={headingColor} fontSize="sm">Select Target Department / Sector</FormLabel>
                    <Select 
                      bg={bundleContainerBg} 
                      borderRadius="xl" 
                      value={assignDept} 
                      onChange={(e) => setAssignDept(e.target.value)}
                    >
                      <option value="All">All Corporate Departments</option>
                      {categories.map((c) => (
                        <option key={c._id} value={c.name}>{c.name}</option>
                      ))}
                    </Select>
                  </FormControl>
                </>
              )}

              <FormControl>
                <FormLabel fontWeight="700" color={headingColor} fontSize="sm">Set Training Due Date (Optional)</FormLabel>
                <Input 
                  type="date" 
                  bg={bundleContainerBg} 
                  borderRadius="xl"
                  value={assignDueDate} 
                  onChange={(e) => setAssignDueDate(e.target.value)} 
                />
                <Text fontSize="xs" color={textColor} mt={1}>
                  Leave empty if there is no deadline. Overdue indicators will trigger automatically after this date.
                </Text>
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter bg="gray.100" borderTop="1px solid" borderColor="gray.200" py={4}>
            <Button variant="ghost" borderRadius="xl" onClick={onAssignClose} mr={3}>
              Cancel
            </Button>
            <Button 
              bgGradient="linear(to-r, purple.500, purple.600)"
              color="white" 
              borderRadius="xl" 
              onClick={handleAssignSubmit}
              isLoading={isAssigning}
              loadingText="Assigning..."
              _hover={{ bgGradient: "linear(to-r, purple.600, purple.700)", transform: "translateY(-2px)" }}
              _active={{ bgGradient: "linear(to-r, purple.600, purple.700)" }}
              transition="all 0.2s"
            >
              Confirm Assignment
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* LIVE COMPLIANCE & PROGRESS REPORT MODAL */}
      <Modal isOpen={isReportOpen} onClose={onReportClose} size="full">
        <ModalOverlay backdropFilter="blur(8px)" />
        <ModalContent m={6} borderRadius="3xl" overflow="hidden" boxShadow="2xl" bg={bundleContainerBg} color={headingColor}>
          <ModalHeader className="premium-gradient" color="white" py={6}>
            <Flex align="center" justify="space-between" wrap="wrap" gap={4}>
              <VStack align="flex-start" spacing={1}>
                <Heading size="md" fontWeight="800">📊 Compliance & Progress Dashboard</Heading>
                <Text fontSize="sm" opacity={0.9} fontWeight="semibold">Real-time status for course: {activeCourseTitle}</Text>
              </VStack>
              <HStack spacing={4} wrap="wrap">
                <FormControl w="150px">
                  <FormLabel fontSize="10px" m={0} opacity={0.8}>Start Date (From)</FormLabel>
                  <Input 
                    type="date" 
                    size="sm" 
                    bg="whiteAlpha.200" 
                    border="none"
                    color="white"
                    value={reportStartDate}
                    onChange={(e) => setReportStartDate(e.target.value)}
                  />
                </FormControl>
                <FormControl w="150px">
                  <FormLabel fontSize="10px" m={0} opacity={0.8}>End Date (To)</FormLabel>
                  <Input 
                    type="date" 
                    size="sm" 
                    bg="whiteAlpha.200" 
                    border="none"
                    color="white"
                    value={reportEndDate}
                    onChange={(e) => setReportEndDate(e.target.value)}
                  />
                </FormControl>
              </HStack>
              
              <HStack spacing={3}>
                <Button 
                  size="sm" 
                  colorScheme="whiteAlpha" 
                  onClick={handleDownloadCSV}
                >
                  📥 Download CSV Report
                </Button>
                <Button 
                  size="sm" 
                  colorScheme="whiteAlpha"
                  bg={bundleContainerBg}
                  color="purple.700"
                  _hover={{ bg: 'gray.100' }}
                  onClick={handleDownloadExcel}
                >
                  📥 Download styled XLSX Excel
                </Button>
              </HStack>
            </Flex>
          </ModalHeader>
          <ModalCloseButton color="white" top={6} />
          <ModalBody p={8} overflowY="auto" bg={emptyBundleBg}>
            {isReportLoading ? (
              <VStack py={20} spacing={4}>
                <Spinner size="xl" color="purple.500" />
                <Text color={textColor} fontWeight="600">Generating compliance report...</Text>
              </VStack>
            ) : enrollmentReport.length === 0 ? (
              <VStack py={20} spacing={2} textAlign="center">
                <Text fontSize="xl" fontWeight="700" color={headingColor}>No Assignments Yet</Text>
                <Text color={textColor}>This course has not been assigned or enrolled by any corporate employee yet.</Text>
              </VStack>
            ) : (
              <Box overflowX="auto" bg={bundleContainerBg} borderRadius="2xl" boxShadow="sm" p={4} border="1px solid" borderColor={bundleContainerBorder}>
                <Table variant="simple" size="md">
                  <Thead bg={emptyBundleBg}>
                    <Tr>
                      <Th fontWeight="800">Employee</Th>
                      <Th fontWeight="800">Department</Th>
                      <Th fontWeight="800">Sector</Th>
                      <Th fontWeight="800" textAlign="center">Compliance Status</Th>
                      <Th fontWeight="800">Course Progress</Th>
                      <Th fontWeight="800">Due Date</Th>
                      <Th fontWeight="800" textAlign="center">Overdue</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {enrollmentReport.map((item, idx) => {
                      const isOverdue = item.dueDate && new Date() > new Date(item.dueDate) && item.status !== 'Completed';
                      let badgeColor = "gray";
                      let statusText = item.status || "Not Started";

                      if (item.status === 'Completed') badgeColor = "green";
                      else if (item.status === 'In Progress') badgeColor = "orange";
                      else if (item.status === 'Not Started') badgeColor = "yellow";

                      if (isOverdue) {
                        badgeColor = "red";
                        statusText = "Overdue ⏰";
                      }

                      return (
                        <Tr key={idx} _hover={{ bg: 'gray.50/50' }}>
                          <Td>
                            <Box>
                              <Text fontWeight="700" color={headingColor}>{item.userId?.fullName || 'N/A'}</Text>
                              <Text fontSize="xs" color={textColor}>{item.userId?.email || 'N/A'}</Text>
                            </Box>
                          </Td>
                          <Td fontWeight="semibold" color="gray.600">{item.userId?.department || 'N/A'}</Td>
                          <Td color={textColor}>{item.userId?.sector || 'N/A'}</Td>
                          <Td textAlign="center">
                            <Badge 
                              colorScheme={badgeColor} 
                              variant="solid" 
                              borderRadius="full" 
                              px={3.5} 
                              py={1} 
                              fontSize="xs"
                              fontWeight="800"
                            >
                              {statusText}
                            </Badge>
                          </Td>
                          <Td minW="150px">
                            <VStack align="stretch" spacing={1}>
                              <Text fontSize="xs" fontWeight="700" textAlign="right" color="purple.700">
                                {item.progress}%
                              </Text>
                              <Progress 
                                value={item.progress} 
                                size="xs" 
                                colorScheme={item.status === 'Completed' ? 'green' : 'purple'} 
                                borderRadius="full" 
                              />
                            </VStack>
                          </Td>
                          <Td fontWeight="semibold" color={isOverdue ? 'red.600' : 'gray.600'}>
                            {item.dueDate ? new Date(item.dueDate).toLocaleDateString() : 'N/A'}
                          </Td>
                          <Td textAlign="center">
                            {isOverdue ? (
                              <Badge colorScheme="red" variant="subtle" borderRadius="xl" px={2.5}>Yes ⏰</Badge>
                            ) : (
                              <Text color={creatorTextColor} fontSize="sm">-</Text>
                            )}
                          </Td>
                        </Tr>
                      );
                    })}
                  </Tbody>
                </Table>
              </Box>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* CREATE COURSE BUNDLE MODAL */}
      <Modal isOpen={isCreateBundleOpen} onClose={onCreateBundleClose} size="lg">
        <ModalOverlay backdropFilter="blur(8px)" />
        <ModalContent borderRadius="2xl" overflow="hidden" boxShadow="2xl" bg={bundleContainerBg} color={headingColor}>
          <ModalHeader className="premium-gradient" color="white" py={5}>
            <VStack align="flex-start" spacing={1}>
              <Text fontSize="lg" fontWeight="800">📦 {isBundleEditMode ? "Edit Course Bundle" : "Create Course Bundle"}</Text>
              <Text fontSize="xs" opacity={0.9} fontWeight="semibold">{isBundleEditMode ? "Modify bundle details and select which courses to include or exclude." : "Combine multiple training modules into a single cohort target."}</Text>
            </VStack>
          </ModalHeader>
          <ModalCloseButton color="white" top={5} />
          
          <ModalBody py={6} px={8}>
            <VStack spacing={6}>
              <FormControl isRequired>
                <FormLabel fontWeight="700" color={headingColor} fontSize="sm">Bundle Title</FormLabel>
                <Input 
                  placeholder="e.g. Core Accounting & Finance Roster" 
                  value={bundleTitle} 
                  onChange={(e) => setBundleTitle(e.target.value)} 
                  borderRadius="xl"
                  bg={bundleContainerBg}
                />
              </FormControl>

              <FormControl>
                <FormLabel fontWeight="700" color={headingColor} fontSize="sm">Description / Scope</FormLabel>
                <Textarea 
                  placeholder="Briefly describe the purpose of this learning bundle..." 
                  value={bundleDesc} 
                  onChange={(e) => setBundleDesc(e.target.value)} 
                  borderRadius="xl"
                  bg={bundleContainerBg}
                  rows={3}
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel fontWeight="700" color={headingColor} fontSize="sm" mb={3}>
                  Select Courses to Include ({selectedCourses.length} selected)
                </FormLabel>
                <Box 
                  maxH="200px" 
                  overflowY="auto" 
                  border="1px solid" 
                  borderColor="gray.200" 
                  borderRadius="xl" 
                  p={4} 
                  bg={emptyBundleBg}
                >
                  {allCoursesRaw.length === 0 ? (
                    <Text fontSize="xs" color={textColor}>No active courses available to bundle.</Text>
                  ) : (
                    <Stack spacing={2.5}>
                      {allCoursesRaw.map(course => (
                        <Checkbox 
                          key={course._id} 
                          value={course._id}
                          colorScheme="purple"
                          isChecked={selectedCourses.includes(course._id)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedCourses(prev => [...prev, course._id]);
                            } else {
                              setSelectedCourses(prev => prev.filter(id => id !== course._id));
                            }
                          }}
                        >
                          <Text fontSize="sm" fontWeight="600" color={headingColor}>{course.title}</Text>
                        </Checkbox>
                      ))}
                    </Stack>
                  )}
                </Box>
              </FormControl>
            </VStack>
          </ModalBody>

          <ModalFooter bg={emptyBundleBg} borderTop="1px solid" borderColor={bundleContainerBorder} py={4}>
            <Button variant="ghost" borderRadius="xl" onClick={onCreateBundleClose} mr={3}>
              Cancel
            </Button>
            <Button 
              bgGradient="linear(to-r, purple.500, purple.600)"
              color="white" 
              borderRadius="xl" 
              onClick={handleCreateBundleSubmit}
              isLoading={isBundleCreating}
              loadingText={isBundleEditMode ? "Saving..." : "Creating..."}
              _hover={{ bgGradient: "linear(to-r, purple.600, purple.700)", transform: "translateY(-2px)" }}
              _active={{ bgGradient: "linear(to-r, purple.600, purple.700)" }}
              transition="all 0.2s"
            >
              {isBundleEditMode ? "Save Changes" : "Create Bundle"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* INVITE EMPLOYEE TO BUNDLE MODAL */}
      <Modal isOpen={isBundleInviteOpen} onClose={onBundleInviteClose} size="md">
        <ModalOverlay backdropFilter="blur(8px)" />
        <ModalContent borderRadius="2xl" overflow="hidden" boxShadow="2xl" bg={bundleContainerBg} color={headingColor}>
          <ModalHeader className="premium-gradient" color="white" py={5}>
            <VStack align="flex-start" spacing={1}>
              <Text fontSize="lg" fontWeight="800">🚀 Invite Employee to Bundle</Text>
              <Text fontSize="xs" opacity={0.9} fontWeight="semibold">Bundle: {activeBundleTitle}</Text>
            </VStack>
          </ModalHeader>
          <ModalCloseButton color="white" top={5} />
          
          <ModalBody py={6} px={8}>
            <VStack spacing={6}>
              <FormControl isRequired>
                <FormLabel fontWeight="700" color={headingColor} fontSize="sm">Employee Corporate Email</FormLabel>
                <Input 
                  placeholder="employee@company.com" 
                  value={bundleInviteEmail} 
                  onChange={(e) => setBundleInviteEmail(e.target.value)} 
                  borderRadius="xl"
                  bg={bundleContainerBg}
                />
              </FormControl>

              <FormControl>
                <FormLabel fontWeight="700" color={headingColor} fontSize="sm">Set Unified Due Date</FormLabel>
                <Input 
                  type="date"
                  value={bundleInviteDueDate} 
                  onChange={(e) => setBundleInviteDueDate(e.target.value)} 
                  borderRadius="xl"
                  bg={bundleContainerBg}
                />
                <Text fontSize="xs" color={textColor} mt={1}>
                  Leave empty if there is no deadline. Overdue indicators will trigger automatically for all bundled courses after this date.
                </Text>
              </FormControl>
            </VStack>
          </ModalBody>

          <ModalFooter bg={emptyBundleBg} borderTop="1px solid" borderColor={bundleContainerBorder} py={4}>
            <Button variant="ghost" borderRadius="xl" onClick={onBundleInviteClose} mr={3}>
              Cancel
            </Button>
            <Button 
              bgGradient="linear(to-r, purple.500, purple.600)"
              color="white" 
              borderRadius="xl" 
              onClick={handleBundleInviteSubmit}
              isLoading={isInviteSubmitting}
              loadingText="Sending Invite..."
              _hover={{ bgGradient: "linear(to-r, purple.600, purple.700)", transform: "translateY(-2px)" }}
              _active={{ bgGradient: "linear(to-r, purple.600, purple.700)" }}
              transition="all 0.2s"
            >
              Verify & Send Invite
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Courses;
